// extracted by mini-css-extract-plugin
export default {"open-status":"style_open-status__nFre-","close-status":"style_close-status__ADQr0","status":"style_status__pUW8b","icon":"style_icon__-Rqmm"};